import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, ORG, LOGO } from "../data/site";
import { cx } from "./ui-kit";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const navItemClass = ({ isActive }) =>
    cx(
      "px-3 py-2 rounded-lg text-base font-medium transition-colors",
      isActive
        ? "text-orange-700 bg-orange-50"
        : "text-stone-700 hover:text-orange-700 hover:bg-orange-50"
    );

  return (
    <header
      className="bg-white/95 backdrop-blur-md sticky top-0 z-40 border-b border-stone-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 gap-4">
          <Link
            to="/"
            className="flex items-center gap-3 rounded-lg"
            data-testid="logo-home-link"
            aria-label={`${ORG} home`}
          >
            <img
              src={LOGO}
              alt="Spire Inclusion logo: a colourful circular emblem of stylised people reaching upwards together."
              className="h-12 w-12 object-contain"
            />
            <span className="font-heading text-xl font-bold text-stone-900">{ORG}</span>
          </Link>

          <nav className="hidden xl:flex items-center gap-1" aria-label="Main navigation">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={navItemClass}
                data-testid={`nav-${l.to === "/" ? "home" : l.to.replace(/\//g, "")}-link`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <button
            type="button"
            className="xl:hidden inline-flex items-center justify-center h-12 w-12 rounded-xl border-2 border-stone-300 text-stone-800 hover:bg-stone-100"
            aria-expanded={open}
            aria-controls="mobile-nav"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          id="mobile-nav"
          className="xl:hidden border-t border-stone-200 bg-white"
          aria-label="Mobile navigation"
        >
          <ul className="px-4 py-4 space-y-1">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.to === "/"}
                  className={({ isActive }) =>
                    cx(
                      "block px-4 py-3 rounded-xl text-lg font-medium",
                      isActive
                        ? "text-orange-700 bg-orange-50"
                        : "text-stone-800 hover:bg-stone-100"
                    )
                  }
                  data-testid={`mobile-nav-${l.to === "/" ? "home" : l.to.replace(/\//g, "")}-link`}
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};
